import React, { createContext, useContext } from 'react';

export const FormConfigContext = createContext({});

// Context Provider
export const FormConfigProvider = ({ children, config }) => {
  return (
    <FormConfigContext.Provider value={config}>
      {children}
    </FormConfigContext.Provider>
  );
};


